import { Component } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { LBButton, LBInput } from '@linearb/buzz';

export const CopyTextWithLabel = ({ text, preview = text, label }) => {
  return (
    <Flex items='center'>
      {label && (
        <Text
          size='medium'
          color='shuttleGray'
          mr='0.5rem'
          width='6rem'
          align='end'
        >
          {label}
        </Text>
      )}
      <CopiableTextArea text={text}>
        <LBInput disabled value={preview} />
      </CopiableTextArea>
    </Flex>
  );
};

class CopiableTextArea extends Component<any> {
  onClick(text) {
    const { onCopy } = this.props;
    copy(text);
    if (onCopy) {
      onCopy();
    }
  }

  render() {
    const {
      text,
      description = '',
      buttonText = 'Copy',
      disableCopy = false,
      children
    } = this.props;

    return (
      <Flex
        justify='space-between'
        content='flex-start'
        items='flex-start'
        direction='column'
      >
        {description && (
          <Text size='small' color='gray' pb='0.1rem' pl='0.2rem'>
            {description}
          </Text>
        )}
        <div className='flex flex-row gap-2'>
          <>{children}</>
          <LBButton
            variant='outline'
            onClick={() => this.onClick(text)}
            disabled={disableCopy}
          >
            {buttonText}
          </LBButton>
        </div>
      </Flex>
    );
  }
}

// @ts-expect-error we should deprecate proptypes
CopiableTextArea.propTypes = {
  text: PropTypes.string.isRequired,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  disableCopy: PropTypes.bool,
  onCopy: PropTypes.func
};
